<template>
  <div class="cluebar">
    <button type="button" class="cluebar__arrow" aria-label="Previous clue" @pointerdown.prevent="$emit('jump', -1)">‹</button>
    <button type="button" class="cluebar__text" @pointerdown.prevent="$emit('toggle')">
      <span v-if="clue" class="cluebar__line">
        <span class="cluebar__num">{{ clue.num }}{{ dir === 'across' ? 'A' : 'D' }}</span>
        <span class="cluebar__clue">{{ clue.clue }}</span>
      </span>
      <span v-if="cross" class="cluebar__cross">
        <span class="cluebar__num">{{ cross.num }}{{ dir === 'across' ? 'D' : 'A' }}</span>
        <span class="cluebar__cross-clue">{{ cross.clue }}</span>
      </span>
    </button>
    <button type="button" class="cluebar__arrow" aria-label="Next clue" @pointerdown.prevent="$emit('jump', 1)">›</button>
  </div>
</template>

<script>
// The current clue, between grid and keyboard, where the thumb already is.
// Tapping it flips direction; the arrows walk the clue list. Under it, dimmed,
// the crossing clue through the cursor square, so both are in view on a
// phone too (Matt, 2026-10-10) - one line, clipped, so the bar never jumps.
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ClueBar',
  emits: ['jump', 'toggle'],
  computed: {
    ...mapState({ dir: (s) => s.cursor.dir }),
    ...mapGetters({ clue: 'currentClue', cross: 'crossClue' }),
  },
};
</script>

<style lang="scss" scoped>
.cluebar {
  display: flex;
  align-items: stretch;
  background: var(--accent);
  color: #211a05;
  min-height: 60px;
  // A break from the grid's bottom row (Seth, 2026-10-09).
  margin-top: 8px;
}

.cluebar__arrow {
  flex: 0 0 44px;
  font-size: 1.6rem;
  font-weight: 700;
  color: inherit;
  opacity: 0.75;
}

.cluebar__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  text-align: left;
  color: inherit;
  padding: 6px 4px;
  line-height: 1.25;
}

.cluebar__line { display: flex; align-items: center; gap: 0.5rem; }

.cluebar__cross {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  min-width: 0;
  opacity: 0.62;
  font-size: 0.78rem;
  .cluebar__num { font-size: 0.7rem; }
}

.cluebar__cross-clue {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cluebar__num { font-weight: 800; font-size: 0.8rem; flex-shrink: 0; }
.cluebar__clue { font-size: 0.95rem; font-weight: 500; }
</style>
